import React from 'react'

const About = () => {
  return (
    <div className='container my-5'>
      <div class="d-flex justify-content-center">
        <h4><b>"Writing is the silent conversation you have with yourself" <sub>- Shannon L. Alder</sub></b></h4>
      </div>
    </div>
  )
}

export default About
